<!-- Copyright (c) 2024 MOCA Systems, Inc.  All rights reserved. -->

<!-- the simplest version, potentially switch to lower level management of panels -->
<ng-content></ng-content>
